export enum MetaDataPlatform {
  CONSUMER_PORTAL = 'Consumer Portal',
}
